import React from "react";
import { createColumnHelper } from "@tanstack/react-table";
import { Popover } from "ui-components/popover/popover";

const columnHelper = createColumnHelper<any>();

export const getOutboundSummaryColumns = (handleViewInboundFreights: (s: any, typeOfFreight: string) => void, handleRedirect: (s: any, d?: any) => void) => [
  columnHelper.accessor("type", {
    id: "type",
    header: "",
    cell: (cellProps) => {
      return <div style={{ display: 'flex', alignItems: 'center' }}>
        <div
          style={{
            fontWeight: 600,
            color: "rgba(79, 95, 114, 0.72)",
            marginRight: 4,
            textAlign: "left",
          }}
        >
          {cellProps.getValue()}
        </div>
        {cellProps.row.original.type === 'ETA Window' && <Popover values={<div>Earliest – Latest expected arrival dates</div>} />}
      </div>
    },
    size: 170,
  }),
  columnHelper.accessor("unassigned", {
    id: "unassigned",
    header: () => <div style={{ textAlign: "left" }}>Unassigned Pickups</div>,
    cell: (cellProps) => {
      const value = cellProps.getValue();
      const isClickable =
        value !== '-' && cellProps.row.original.type === 'No. of Shipments';

      return (
        <div
          style={{
            marginRight: 5,
            textAlign: "left",
            cursor: isClickable ? "pointer" : "default",
            color: isClickable ? "#2F80ED" : "#000",
          }}
          onClick={() => {
            if (isClickable) {
              handleRedirect("unassigned", cellProps.row.original.terminalDetails.terminalNumber);
            }
          }}
        >
          {value}
        </div>
      );
    },
    size: 150,
  }),
  columnHelper.accessor("assigned", {
    id: "assigned",
    header: () => <div style={{ textAlign: "left", }}>Assigned Pickups</div>,
    cell: (cellProps) => {
      const value = cellProps.getValue();
      const isClickable =
        value !== '-' && cellProps.row.original.type === 'No. of Shipments';

      return (
        <div
          style={{
            marginRight: 5,
            textAlign: "left",
            cursor: isClickable ? "pointer" : "default",
            color: isClickable ? "#2F80ED" : "#000",
          }}
          onClick={() => {
            if (isClickable) {
              handleRedirect("assigned", cellProps.row.original.terminalDetails.terminalNumber);
            }
          }}
        >
          {value}
        </div>
      );
    },
    size: 150,
  }),
  columnHelper.accessor("completed", {
    id: "completed",
    header: () => <div style={{ textAlign: "left" }}>Completed Pickups</div>,
    cell: (cellProps) => {
      const value = cellProps.getValue();
      const isClickable =
        value !== '-' && cellProps.row.original.type === 'No. of Shipments';

      return (
        <div
          style={{
            marginRight: 5,
            textAlign: "left",
            cursor: isClickable ? "pointer" : "default",
            color: isClickable ? "#2F80ED" : "#000",
          }}
          onClick={() => {
            if (isClickable) {
              handleRedirect("completed", cellProps.row.original.terminalDetails.terminalNumber);
            }
          }}
        >
          {value}
        </div>
      );
    },
    size: 150,
  }),
  columnHelper.accessor("inhouse", {
    id: "inhouse",
    header: () => <div style={{ textAlign: "left" }}>In-House Freight</div>,
    cell: (cellProps) => {
      const value = cellProps.getValue();
      const isEta = cellProps.row.original.type === "ETA Window";
      const isShipments = cellProps.row.original.type === "No. of Shipments";

      const isClickable = value !== "-" && (isEta || isShipments);

      return (
        <div
          style={{
            marginRight: 5,
            textAlign: "left",
            cursor: isClickable ? "pointer" : "default",
            color: isClickable ? "#2F80ED" : "#000",
          }}
          onClick={() => {
            if (!isClickable) return;

            if (isEta) {
              handleViewInboundFreights(
                cellProps.row.original,
                "inhouse"
              );
            } else if (isShipments) {
              handleRedirect(
                "inhouse",
                cellProps.row.original.terminalDetails.terminalNumber
              );
            }
          }}
        >
          {value}
        </div>
      );
    }
    ,
    size: 150,
  }),
  columnHelper.accessor("inbound", {
    id: "inbound",
    header: () => <div style={{ textAlign: "left" }}>Inbound Freight</div>,
    cell: (cellProps) => {
      const value = cellProps.getValue();
      const isEta = cellProps.row.original.type === "ETA Window";
      const isShipments = cellProps.row.original.type === "No. of Shipments";

      const isClickable = value !== "-" && (isEta || isShipments);

      return (
        <div
          style={{
            marginRight: 5,
            textAlign: "left",
            cursor: isClickable ? "pointer" : "default",
            color: isClickable ? "#2F80ED" : "#000",
          }}
          onClick={() => {
            if (!isClickable) return;

            if (isEta) {
              handleViewInboundFreights(
                cellProps.row.original,
                "inbound"
              );
            } else if (isShipments) {
              handleRedirect(
                "inbound",
                cellProps.row.original.terminalDetails.terminalNumber
              );
            }
          }}
        >
          {value}
        </div>
      );
    },
    size: 150,
  }),
  columnHelper.accessor("total", {
    id: "total",
    header: () => <div style={{ textAlign: "left" }}>Total</div>,
    cell: (cellProps) => {
      const value = cellProps.getValue();
      return (
        <div
          style={{
            marginRight: 5,
            textAlign: "left",
          }}
        >
          {value}
        </div>
      );
    },
    size: 150,
  }),
];
